import React from "react";
import PropTypes from "prop-types";

import ReactSlider from "react-slider";

export default class EventFactorSlider extends React.PureComponent {

    static propTypes = {
        eventFactor: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            eventThresholdValidationMessage: null
        };
    }

    render() {

        const { eventFactor } = this.props;
        const eventFactorName = document.getEventName({type: eventFactor.type});

        return (
            <div className="event-factor-slider">
                <div className="event-factor-slider-label">
                    {eventFactorName}
                </div>
                <div className="slider-container">
                    <ReactSlider
                        min={0}
                        max={5}
                        value={eventFactor.weight}
                        step={1}
                        marks
                        markClassName="event-factor-slider-mark"
                        thumbClassName="event-factor-slider-thumb"
                        renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                        trackClassName="event-factor-slider-track"
                        onChange={this.props.onChange}
                        disabled={false}
                    />
                </div>
            </div>
        );

    };
}